export default "__VITE_ASSET__C997S8MO__"